import { Injectable } from '@angular/core';
import { ApiConnectionsModel, ApiConnectionsRepository } from '@database/central';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiUrlProvider {
	public constructor(private apiConnectionsRepository: ApiConnectionsRepository) {}

	public getUrl$(connectionId: string): Observable<string | null> {
		return this.apiConnectionsRepository
			.getConnectionDetails$(connectionId)
			.pipe(map((connectionDetails: ApiConnectionsModel | null) => connectionDetails.serverPath));
	}
}
